import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { useNow } from "@/hooks/useNow";
import { isLive, isFeatured, money, cheapestDrink } from "@/lib/hh";

export function TonightsPicks({ venues }) {
  const now = useNow(30000);
  const picks = venues.filter((v) => isLive(v, now)).sort((a, b) => (isFeatured(b) - isFeatured(a)) || (a.distance ?? 0) - (b.distance ?? 0)).slice(0, 10);
  if (!picks.length) return null;
  return (
    <section data-testid="tonights-picks" className="mt-10">
      <div className="mb-4 flex items-center gap-2">
        <Flame className="text-orange-400" size={20} />
        <h2 className="font-heading text-3xl text-white sm:text-4xl">Tonight's Picks</h2>
        <span className="text-sm text-zinc-500">· open right now</span>
      </div>
      <div className="no-scrollbar -mx-4 flex snap-x gap-4 overflow-x-auto px-4 pb-2">
        {picks.map((v) => {
          const drink = cheapestDrink(v);
          return (
            <Link
              key={v.id}
              to={`/venue/${v.id}`}
              data-testid={`pick-${v.id}`}
              className="w-72 shrink-0 snap-start rounded-2xl border border-[#fde68a]/30 bg-[#141419] p-5 shadow-[0_0_30px_-12px_rgba(250,204,21,0.5)] transition-transform hover:-translate-y-1"
            >
              <StatusBadge venue={v} testId={`pick-status-${v.id}`} />
              <h3 className="font-heading mt-3 truncate text-2xl text-white">{v.name}</h3>
              <p className="text-sm text-zinc-400">{v.distance != null ? `${v.distance} mi away` : v.city}</p>
              {drink !== Infinity && <p className="mt-3 text-sm text-zinc-300">Drinks from <span className="text-lg font-extrabold text-[#fde68a]">{money(drink)}</span></p>}
            </Link>
          );
        })}
      </div>
    </section>
  );
}
